import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FocusTrapComponent } from './focus-trap.component';

@NgModule({
  declarations: [FocusTrapComponent],
  imports: [CommonModule],
  exports: [FocusTrapComponent],
})
export class FocusTrapModule {}
